import React, { Component } from "react";
import {
  Breadcrumb,
  PageHeader,
  ListGroup,
  ListGroupItem,
  Glyphicon,
  Grid
  } from "react-bootstrap";
import './Service.css';

export default class Service extends Component {
  constructor(props) {
	super(props);
	this.state = {
	  isLoading: true
	};
  }
  render() {
    return (
      <div className="Service">
      <Grid>
	    <Breadcrumb>
	      <Breadcrumb.Item href="/">Inicio</Breadcrumb.Item>
	      <Breadcrumb.Item active>Servicios</Breadcrumb.Item>
	    </Breadcrumb>
	    <PageHeader>
	      Servicios
	    </PageHeader>
	    <ListGroup>
	      <ListGroupItem><Glyphicon glyph='ok' />Detalle de Libro Banco.</ListGroupItem>
	      <ListGroupItem><Glyphicon glyph='ok' />C&aacute;lculo y Prorrateo de los gastos comunes entre los copropietarios.</ListGroupItem>
	      <ListGroupItem><Glyphicon glyph='ok' />Avisos de cobro personalizados y detallados a deudores con mas de dos meses.</ListGroupItem>
	      <ListGroupItem><Glyphicon glyph='ok' />Detalle de los consumos individuales de agua caliente y calefacci&oacute;n.</ListGroupItem>
	      <ListGroupItem><Glyphicon glyph='ok' />Listado de multas y otros cobros.</ListGroupItem>
	      <ListGroupItem><Glyphicon glyph='ok' />Listado de copropietarios morosos.</ListGroupItem>
	      <ListGroupItem><Glyphicon glyph='ok' />Listado detallado de los egresos del mes.</ListGroupItem>
	      <ListGroupItem><Glyphicon glyph='ok' />Estado Fondo de Reserva.</ListGroupItem>
	      <ListGroupItem><Glyphicon glyph='ok' />Comprobantes de egresos.</ListGroupItem>
	      <ListGroupItem><Glyphicon glyph='ok' />Listado de todos los pagos recibidos.</ListGroupItem>
	      <ListGroupItem><Glyphicon glyph='ok' />Recibos de pago personalizados.</ListGroupItem>
	      <ListGroupItem><Glyphicon glyph='ok' />Resumen de remuneraciones.</ListGroupItem>
	      <ListGroupItem><Glyphicon glyph='ok' />Resumen de leyes sociales.</ListGroupItem>
	      <ListGroupItem><Glyphicon glyph='ok' />Listado de Ingresos Especiales.</ListGroupItem>
	      <ListGroupItem><Glyphicon glyph='ok' />Consolidado de los &uacute;ltimos 12 meses.</ListGroupItem>
	      <ListGroupItem><Glyphicon glyph='ok' />Evoluci&oacute;n de los gastos separados por rubros.</ListGroupItem>
	      <ListGroupItem><Glyphicon glyph='ok' />Gr&aacute;ficos de gastos totales y por rubros en los &uacute;ltimos 12 meses.</ListGroupItem>
	      <ListGroupItem><Glyphicon glyph='ok' />Evoluci&oacute;n de la morosidad total en el &uacute;ltimo año.</ListGroupItem>
	      <ListGroupItem><Glyphicon glyph='ok' />Balance de ingresos y egresos en los &uacute;ltimos 12 meses.</ListGroupItem>
	      <ListGroupItem><Glyphicon glyph='ok' />Listado de egresos e ingresos</ListGroupItem>
	    </ListGroup>
      </Grid>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Service.js